module.exports = __webpack_public_path__ + "static/media/colorchart_cowhide.6512cfce.jpg";